/* eslint-disable max-len */
import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Pane, Text } from '@leverege/ui-elements';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import ConditionFilterModel from "./ConditionFilterModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.conditionFilter.ConditionFilterModelEditor');
export default function ConditionFilterModelEditor(props) {
  const {
    value,
    relationship
  } = props;
  const onChange = useValueChange(ConditionFilterModel, props);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "conditionFilterEditor|editor",
    layout: "flex:colL",
    children: ModelEditorFactory.create(value.rootCondition, {
      ...props,
      onChange,
      eventData: 'setRootCondition',
      preamble: /*#__PURE__*/_jsx(Text, {
        variant: "conditionTitle",
        dangerouslySetInnerHTML: {
          __html: t('onThisPage', {
            name: `<b>${relationship.name.toLowerCase()}</b>`
          })
        }
      })
    })
  });
}